import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function callDownListReportReducer(
  state: ReportDto = initialState.callDownListReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_CALL_DOWN_LIST_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
